/**
 * Composant Tags Input
 * Gère les champs de type tags avec ajout/suppression
 */

import { logger } from '../../core/base.js';

/**
 * Initialise les champs tags
 */
export function initTagsInputs() {
    document.querySelectorAll('.ui-input-tags').forEach(field => {
        field.addEventListener('click', (event) => {
            if (event.target.classList.contains('is-delete')) {
                const control = event.target.closest('.ui-control');
                control.parentNode.removeChild(control);
            }
        });

        const template = field.querySelector('template');
        const textInput = field.querySelector('input[type=text]');

        textInput.addEventListener('change', (event) => {
            const element = document.importNode(template.content, true);
            element.querySelector('.ui-tag.tone-info').textContent = event.target.value;
            element.querySelector('input').value = event.target.value;

            template.before(element);

            event.target.value = '';
            setTimeout(() => {
                event.target.focus();
            }, 1);
        });
    });

    logger.debug('Tags inputs initialized');
}

/**
 * Initialise le formulaire de tags auto-submit
 */
export function initTagsForm() {
    document.querySelectorAll('form#tags').forEach(form => {
        form.querySelectorAll('.ui-tag.tone-info').forEach(tag => {
            tag.addEventListener('click', event => {
                event.preventDefault();

                tag.remove();

                form.submit();
            });
        });

        document.querySelectorAll('.arcate-block-publication-tags .ui-tag.tone-info').forEach(tag => {
            tag.addEventListener('click', event => {
                event.preventDefault();

                const input = document.createElement('input');
                input.setAttribute('type', 'hidden');
                input.setAttribute('name', 'tags');
                input.setAttribute('value', tag.innerText);
                form.append(input);

                form.submit();
            });
        });
    });

    logger.debug('Tags form initialized');
}

// Auto-initialisation
document.addEventListener('DOMContentLoaded', () => {
    initTagsInputs();
    initTagsForm();
});
